<script setup lang="ts">
const {
  isPanelOpen,
  isPanelExpanded,
  isClosePanelConfirmationOpen,
  openPanel,
  closePanel,
  hideClosePanelConfirmation,
  addClosePanelHook,
} = usePanel();

const chatStore = useChatStore();

addClosePanelHook(() => {
  // Clear chat
  chatStore.reset();
});
</script>

<template>
  <div class="widget-layout">
    <Transition name="fade-up">
      <WidgetButton v-show="!isPanelOpen" @click="openPanel"></WidgetButton>
    </Transition>
    <Transition name="fade-up">
      <WidgetPanel v-show="isPanelOpen" :expanded="isPanelExpanded">
        <slot></slot>
        <ModalConfirm
          v-model="isClosePanelConfirmationOpen"
          confirm="Chat afsluiten"
          deny="Annuleren"
          @confirm="closePanel"
          @deny="hideClosePanelConfirmation"
        ></ModalConfirm>
      </WidgetPanel>
    </Transition>
  </div>
</template>

<style lang="scss" scoped>
.widget-layout {
  position: relative;
  z-index: 9999;
}

.widget-button.fade-up-enter-active,
.widget-button.fade-up-leave-active,
.widget-panel.fade-up-enter-active,
.widget-panel.fade-up-leave-active {
  transition:
    opacity 500ms cubic-bezier(0.16, 1, 0.3, 1),
    transform 500ms cubic-bezier(0.16, 1, 0.3, 1);
}

.widget-button.fade-up-enter-from,
.widget-button.fade-up-leave-to,
.widget-panel.fade-up-enter-from,
.widget-panel.fade-up-leave-to {
  transform: translateY(20%);
  opacity: 0;
}
</style>
